<template>
  <div>
    <div>
        <div v-if="datatecnicohorario === false && dataDetails.statusOcorencia != 3">
          <div class="arquivosModal">
           <div id="title">
              <p class="dadomorador" v-if="disabledTecnico"> Selecione uma data disponível</p>
              <p class="dadomorador" v-else> Selecione um técnico e um engenheiro disponível</p>
          </div>
            <div class="cadastreArquivo-modal">
              <div @click="showModal"><i class="far fa-plus-square"></i> Cadastrar Técnico / Engenheiro</div>
            </div>
          </div>
          <div class="d-flex mt-2 w-100">
            <div class="mr-3 w-50">
              <select :disabled="disabledTecnico" v-if="!disabledTecnico" v-model="formnewoccourence.tecnicoid" class="form-control" @change="changeTecnico">
                <option @click="teste" disabled :value=null>Selecione um técnico</option>
                <option v-for="data in datalAlltenico" :key="data.id" :value="data.id">{{data.nome}}</option>
              </select>
            </div>
            <div class="w-50">
              <select :disabled="disabledTecnico" v-if="!disabledTecnico" v-model="formnewoccourence.engenheiroid" class="form-control" @change="changeEngenheiro">
                <option @click="teste" disabled :value=null>Selecione um Engenheiro</option>
                <option v-for="data in datalAllEngenheiro" :key="data.id" :value="data.id">{{data.nome}}</option>
              </select>
            </div>
          </div>
            <div class="body-calenders" v-if="!twoselect">
              <datepicker
              :disabledDates="disabledDates"
              v-model="formnewoccourence.dataSolicitacao"
              class="datepickerStyle"
              :language="ptBR"
              inline auto-apply
            />
                <div class="w-100 text-center">
                    <div class="mt-1" v-if="formnewoccourence.dataSolicitacao == null">
                    <p class="info-calenders-empty">Selecione um dia no calendário para visualizar a agenda dos técnicos</p>
                  </div>
                  <div v-else class="w-100 text-center">
                    <p id="data-format">{{
                      [formnewoccourence.dataSolicitacao.getDay()]  + ' de ' + this.formnewoccourence.dataSolicitacao.getDate() + ' '  + daysofYears[this.formnewoccourence.dataSolicitacao.getMonth()]}}</p>
                  </div>
                  <div>
                    <div class="hours-noselected" v-if="formnewoccourence.dataSolicitacao == null && dataTenicalHour.length == 0">
                      Nenhuma Data Selecionada!
                    </div>
                    <div class="hours-noselected" v-else-if="formnewoccourence.dataSolicitacao !== null && dataTenicalHour.length == 0">
                      Nenhum Agendamento Encontrado!
                    </div>
                    <div class="hours-tec" v-else>
                        <div v-for="(data, index) in dataTenicalHour" :key="index" class="d-flex justify-content-center hour-compo">
                          <div class="w-100 bg-hour">
                            <div class="hour-head">
                              {{formatHours(data.hours)}}
                            </div>
                            <div class="hour-body">
                              <div v-for="dataocorrence in data.reOccurence" :key="dataocorrence.id" class="mb-1">
                                <div class="d-flex">{{dataocorrence.tecnico.nome  + ' - Apt ' + dataocorrence.empreendimentoUnidade.nomeApartamento}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
          </div>
          <div  v-else>
            <div>
              <p class="dadomorador">Selecione uma disponibilidade de data e hora do morador</p>
              <div id="carousel-moth">
                <i class="fas fa-chevron-left" @click="setMonthDown"></i>
                <div class="mr-3 ml-3 mouthcaorusel">{{ getMonthName }}</div>
                <i  class="fas fa-chevron-right" @click="setMonthplus"></i>
              </div>
            </div>
            <div class="body-calenders-days">
              <i  @click="downstepdays" class="fas fa-chevron-left angel-days" :class="{'invisible-angel': disableleft}" ></i>
              <div class="body-dates">
                <div  v-for="(data, index) in getcarouselDays" :key="data.value" class="text-center">
                  <div class="namefdayWeek">{{GetnameWeek(index)}}</div>
                  <div :id="'day-' + data.value" @click="selectDay(data.value)" class="one-day" :class="{'one-day-disabled': data.disable , 'one-day-active': verificarDataSelcionada(data.value)}">{{data.value}}</div>
                </div>
              </div>
               <i @click="nextstepdays" class="fas fa-chevron-right angel-days" :class="{'invisible-angel': disableright}" ></i>
            </div>
           <div class="body-calenders-hours">
             <div class="body-hours">
              <div class="hour mt-2 ml-1 mr-1 mb-2 "  v-for="data in getDays" :key="data.value" :id="'hour-' + data.value" @click="sethour(data.value)" :class="{'hour-disable': data.disabled, '.hour-active': data.setado,'hour-active': dataDetails.horario == data.value && data.disable}">
                {{ data.value }}
              </div>
            </div>
           </div>
          </div>
        </div>
        <div v-else>
          <div>
          </div>
          <div id="title" class="info-chamados" v-if="dataDetails.statusOcorencia == 1">
            <p class="dadomorador-final"> Informações do Chamado</p>
            <button @click="editadatahoratecnico" class="btn-head mx-1"><i class="fas fa-pen mr-2"></i>EDITAR</button>
          </div>
           <div class="grid-resumo">
              <!-- <div class="container-details-info">
                <label class="label-final">Problema raiz</label>
                  <div class="icone-details">
                     <img :src="iconselector(dataDetails.patalogia)" />
                  </div>
                <p class="text-details-info">{{dataDetails.patologiaText}}</p>
              </div> -->
              <div class="container-details-info">
                <label class="label-final">Data</label>
                   <div class="icone-details">
                    <i class="fas fa-calendar-alt"></i>
                  </div>
                <p class="text-details-info">{{moment(new Date(dataDetails.dataSolicitacao)).format('DD/MM/YYYY')}}</p>
              </div>
              <div class="container-details-info">
                <label class="label-final">Horário</label>
                  <div class="icone-details">
                   <i class="far fa-clock"></i>
                  </div>
                <p class="text-details-info">{{dataDetails.horarioFormatado}}</p>
              </div>
              <div class="container-details-info">
                <label class="label-final">Técnico</label>
                  <div class="icone-details">
                   <i class="fas fa-hammer"></i>
                  </div>
                <p class="text-details-info">{{dataDetails.tecnico.nome}}</p>
              </div>
              <div class="container-details-info">
                <label class="label-final">Engenheiro</label>
                  <div class="icone-details">
                    <i class="fas fa-hard-hat"></i>
                  </div>
                <p class="text-details-info">{{dataDetails.engenheiro.nome}}</p>
              </div>
            </div>
        </div>
        </div>
        <b-modal
     ref="my-modal"
     hide-footer
     title="ADICIONAR NOVO TÉCNICO / ENGENHEIRO"
     >
     <template #modal-title>
          <div class="header-title">ADICIONAR NOVO TÉCNICO</div>
        </template>
     <div class="popupAddTecnico">
      <b-tabs fill>
        <b-tab :title="'Técnico'">
          <template slot="title">
          <div>
            <span class="d-md-down-none pl-1 text-third text-tabs"> <i class="fas fa-hammer mr-2"></i>Técnico</span>
          </div>
        </template>
        <div class="nome-telefone-container">
        <div>
          <div class="titulo-modal-novo-tecnico ">Nome:</div>
          <div class="input-modal-novo-tecnico"><input class="input-pesquisar form-control" v-model="tecnicoObj.nome"></div>
          <!-- v-model="formNewIput.name" -->
        </div>
        <div>
          <div class="titulo-modal-novo-tecnico">Telefone:</div>
          <div class="input-modal-novo-tecnico"><input class="input-pesquisar form-control" v-model="tecnicoObj.telefone" v-mask="['(##) ####-####']"></div>
        </div>
      </div>

      <div class="cpf-data-container">
        <div style="width: 100%">
          <div class="titulo-modal-novo-tecnico mt-3">CPF:</div>
          <div class="input-modal-novo-tecnico"><input class="input-pesquisar form-control" v-model="tecnicoObj.cpf" v-mask="['###.###.###-##']"></div>
        </div>

        <div style="width: 100%">
            <div class="titulo-modal-novo-tecnico mt-3">Data de Nascimento:</div>
            <div class="input-modal-novo-tecnico"><input type="date" class="input-pesquisar form-control" v-model="tecnicoObj.dataNascimento">
            </div>
        </div>
      </div>

        <div class="titulo-modal-novo-tecnico mt-3">EMAIL:</div>
        <div class="input-modal-novo-tecnico"><input class="input-pesquisar form-control" v-model="tecnicoObj.email"></div>
              <div class="buttonTecnico">
        <div class="d-flex mt-3 mr-2 ml-2">
          <button @click="back" class="button-cancel mr-2">
            Cancelar
          </button>
          <button class="button-save ml-2" @click="addTecnico">ADICIONAR</button>
        </div>
      </div>
      </b-tab>
      <b-tab :title="'Engenheiro'">
        <template slot="title">
          <div>
            <span class="d-md-down-none pl-1 text-third text-tabs"> <i class="fas fa-hard-hat mr-2"></i>Engenheiro</span>
          </div>
        </template>
        <div class="nome-telefone-container">
        <div>
          <div class="titulo-modal-novo-tecnico ">Nome:</div>
          <div class="input-modal-novo-tecnico"><input class="input-pesquisar form-control" v-model="engineerObj.nome"></div>
          <!-- v-model="formNewIput.name" -->
        </div>
        <div>
          <div class="titulo-modal-novo-tecnico">Telefone:</div>
          <div class="input-modal-novo-tecnico"><input class="input-pesquisar form-control" v-model="engineerObj.telefone" v-mask="['(##) ####-####']"></div>
        </div>
      </div>

      <div class="cpf-data-container">
        <div style="width: 100%">
          <div class="titulo-modal-novo-tecnico mt-3">CPF:</div>
          <div class="input-modal-novo-tecnico"><input class="input-pesquisar form-control" v-model="engineerObj.cpf" v-mask="['###.###.###-##']"></div>
        </div>

        <div style="width: 100%">
            <div class="titulo-modal-novo-tecnico mt-3">Data de Nascimento:</div>
            <div class="input-modal-novo-tecnico"><input type="date" class="input-pesquisar form-control" v-model="engineerObj.dataNascimento">
            </div>
        </div>
      </div>

        <div class="titulo-modal-novo-tecnico mt-3">EMAIL:</div>
        <div class="input-modal-novo-tecnico"><input class="input-pesquisar form-control" v-model="engineerObj.email"></div>

        <div class="buttonTecnico">
        <div class="d-flex mt-3 mr-2 ml-2">
          <button @click="back" class="button-cancel mr-2">
            Cancelar
          </button>
          <button class="button-save ml-2" @click="addEngenheiro">ADICIONAR</button>
        </div>
      </div>
      </b-tab>
      </b-tabs>
     </div>
    </b-modal>
  </div>
</template>

<script>
import agendatechnical from './agendatechnical'
export default agendatechnical
</script>

<style scoped>
.arquivosModal {
margin-top: 1rem;
display: grid;
grid-template-columns: 1fr 0.7fr;
grid-template-rows: 1fr;
grid-auto-columns: 1fr;
gap: 0px 0px;
grid-auto-flow: row;
grid-template-areas:
  "selecioneArquivo-modal cadastreArquivo-modal";
}
.cadastreArquivo-modal {
grid-area: cadastreArquivo-modal;
font: normal normal bold 15px/24px Segoe UI;
color: #008144;
display: flex;
justify-content: end;
padding-right: 10px;
align-items: end;
}

.dadomorador{
font-family: Segoe UI;
font-weight: bold;
font-size: 14px;
line-height: 0px;
font-weight: bold;
margin-top: 25px;
}

.nome-telefone-container{
display: flex;
  width: 100%;
  gap: 1rem;
  justify-content: space-between;
}

.titulo-modal-novo-tecnico{
  font: normal normal 600 15px/24px Segoe UI;
  color: #606160;
  width: 100%;
  text-align: initial;
}

.input-modal-novo-tecnico{
width: 100%;
}

.nome-telefone-container{
display: grid;
grid-template-columns: 1fr 1fr;
grid-auto-rows: 1fr;
}

.cpf-data-container{
display: flex;
  width: 100%;
  gap: 1rem;
  justify-content: space-between;
}

.buttonTecnico{
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 5px;
}

.cancelaTecnico{
  display: flex;
  width: 170px;
  padding-top: 20px;
  justify-content: center;
}

.cadastraTecnico{
  display: flex;
  width: 170px;
  padding-top: 20px;
  justify-content: center;
}

.input-pesquisar{
  width: 100%;
  height: 2rem;
  border: 1px solid #b9b6b6;
  border-radius: 5px;
  padding-left: 0.5rem;
}

#data-format{
color: #008144;
font-size: 18px;
font-weight: bold;
}

.hours-tec{
border-radius: 15px;
background: #ffffff;
width: 100%;
height: 80%;
overflow-y: auto;
}
.hours-noselected{
display: flex;
border-radius: 15px;
  background: #ffffff;
  width: 100%;
  height: 15rem;
  overflow-y: auto;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-family: 'Segoe UI';
  font-weight: bold;
}

.hour-head{
height: 20px;
width: 100%;
background: #008144;
color: white;
border-radius: 10px 10px 0px 0px;
text-align: left;
padding-left: 15px;
font-weight: bold;
}
.bg-hour{
background: white;
border-radius: 10px 10px 0px 0px;
}

/* .hour-compo{
padding-left: 15px;
} */

.hour-body{
font-weight: bold;
padding: 10px;
color: black;
}

#carousel-moth{
width: 100%;
height: 40px;
border-radius: 10px;
background: #008148;
display: flex;
justify-content: center;
font-size: 22px;
font-weight: bold;
align-items: center;
color: white;
}

.body-calenders-days{
width: 100%;
height: 100px;
display: flex;
justify-content: space-between;
align-items: center;
}

.angel-days{
font-size: 30px;
cursor: pointer;
}

.invisible-angel{
visibility: hidden;
}

.body-dates{
width: 80%;
display: flex;
justify-content: space-between;
}

.namefdayWeek{
font-weight: bold;
font-family: 'Segoe UI';
}

.one-day{
height: 40px;
width: 40px;
border-radius: 50%;
color: rgb(97, 97, 97);
background: white;
font-weight: bold;
border: 1px solid rgb(85, 85, 85);
display: flex;
cursor: pointer;
justify-content: center;
align-items: center;
font-family: Segoe UI;
font-size: 15px;
}
.one-day-active{
background: #008148 !important;
color: white !important;
border: none !important;
font-family: Segoe UI;
font-size: 15px;
}

.one-day-disabled{
background: rgb(160, 160, 160) !important;
color: rgb(112, 112, 112) !important;
font-family: Segoe UI;
font-size: 15px;
}

.body-calenders-hours{
margin-top: 15px;
padding: 15px;
border-radius: 10px;
width: 100%;
background: #DFDFDF;
}

.body-hours{
display: flex;
padding-top: 5px;
padding-bottom: 5px;
padding-left: 10px;
padding-right: 10px;
flex-wrap: nowrap;
justify-content: space-around;
}

.hour{
height: 30px;
width: 60px;
display: flex;
justify-content: center;
border-radius: 10px;
cursor: pointer;
align-items: center;
background: white;
font-family: Segoe UI;
font-size: 15px;
}
.hour-active{
background: #008144 !important;
color: white;
font-family: Segoe UI;
font-size: 15px;
}
.hour-disable{
background: gray !important;
color: rgb(73, 73, 73) !important;
font-family: Segoe UI;
font-size: 15px;
}

.nome-telefone-container{
display: grid;
grid-template-columns: 1fr 1fr;
grid-auto-rows: 1fr;
}

.info-calenders-empty{
color: #008144;
margin-top: 5px;
font-size: 14px;
text-align: center;
font-weight: bold;
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif
}

.vdp-datepicker{
width: auto;
}

.vdp-datepicker__calendar .cell.selected{
background: #008144 !important;
}

.body-calenders{
gap: 1rem;
margin-top: 15px;
display: flex;
padding: 15px;
border-radius: 10px;
width: 100%;
background: #DFDFDF;
}

.dadomorador-final{
font-size: 18px;
line-height: 0px;
font-weight: bold;
margin-top: 25px;
}
.grid-resumo{
  padding: 0 2rem;
    display: flex;
    justify-content: space-between;
    gap: 2rem;
}

.container-details-info{
display: flex;
flex-direction: column;
align-items: center;
gap: 1rem;
}

.label-final{
font: normal normal normal 16px/21px Segoe UI;
margin-top: 25px;
font-size: 17px;
line-height: 0px;
font-weight: bold;
}
.icone-details{
width: 50px;
background: #F2F2F2;
display: flex;
justify-content: center;
font-size: 35px;
align-items: center;
color: #2E973D;
border-radius: 50%;
height: 50px;
}
.text-details-info{
font: normal normal normal 16px/21px Segoe UI;
font-size: 15px;
font-weight: bold;
color: #008148;
}
.button-group{
display: flex;
margin-top: 10px;
}

.btn-head {
background-color: #008148;
  color: white;
  border: none;
  width: 10rem;
  font-weight: bold;
  height: 37px;
  font-size: 16px;
  border-radius: 6px;
}
.info-chamados {
display: flex;
  justify-content: space-between;
  align-items: center;
}
.popupAddTecnico{
display:flex;
gap: 1rem;
flex-direction: column;
}

.mouthcaorusel{
font: normal normal normal 26px Segoe UI;
font-weight: bold;
color: #ffffff;
}
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.button-modal{
    display: flex;
    margin-top: 25px;
    align-items: center;
    height: 10vh;
    justify-content: space-evenly;

}
.button-cancel, .button-save{
  margin-top: 10;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 225px;
  height: 40px;
  font: bold 14px 'Segoe UI';
}

.button-save {
  background-color: #008148;
  color: white;
  font-family: 'Segoe UI';
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/technicalvisit/agendatechnical/agendatechnical.vue